// import React, { useEffect, useState } from "react";
// import "../DashBoard/dashboard.css";
// import {
//  Button,
//  Menu,
//  MenuItem,
// } from "@mui/material";
// import { toast } from "react-toastify";
// import { toastProperties } from "../../commons/Toast/Toaster";
// import { PreviewModel } from "./previewModel";
// import AddBidsModal from "./addBidsModal";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import CountDownTimer from "./countDownTimer";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import { getGeneratorCapacityall } from "../../store/Capacity/actions";
// import { getSelectedCapacityData } from "../../store/DashBoard/actions";
// import { Campaign, CampaignOutlined } from "@mui/icons-material";
// import landingCostCalculatorService from "../../components/Services/landingCostCalculator.service";
// import biddingGeneratorService from "../../components/Services/biddingGenerator.service";
// import { MdFilterList, MdOutlineElectricBolt } from "react-icons/md";
// import Filter from "./filter";
// import ApproveBidsModal from "./approveBidsModal";
// import { GetTokens } from "../../firebase";
// import { getAllNotifications } from "../../store/Notification/action";
// import ChatIcon from "@mui/icons-material/Chat";
// import chatService from "../../components/Services/chat.service";
// import Chat from "../../components/chat/Chat";
// import MainDashboard from "../../components/CommonDashboard/MainDashboard";

// const Dashboard = () => {
//  const allGenCapacity = useSelector(
//   (state) => state?.capacityReducer?.allGenCapacity || []
//  );
//  const role = useSelector((state) => state?.sessionState?.role);
//  const configKey = useSelector((state) => state?.sessionState?.connectionName);

//  const unreadNotificationsObj = useSelector(
//   (state) => state?.notificationReducer?.unreadNotifications
//  );

//  const dispatch = useDispatch();
//  const navigation = useNavigate();

//  const [isModel, setIsModel] = useState(false);
//  const [isAddBidsModal, setIsAddBidsModal] = useState(false);
//  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
//  const [selectedCardData, setSelectedCardData] = useState(null);
//  const [matchingProfiles, setMatchingProfiles] = useState(null);
//  const [bidItem, setbidItem] = useState();
//  const [isBidPlaced, setIsBidPlaced] = useState({});
//  const [bidsListing, setBidsListing] = useState([]);
//  const [isApproveBidsModal, setIsApproveBidsModal] = useState(false);
//  const [connectionData, setConnectionData] = useState();
//  const [isTokenFound, setTokenFound] = useState(false);
//  const [statusDropDownValue, setStatusDropDownValue] = useState("");
//  const [formResetFlag, setFormResetFlag] = useState(false);
//  const [sortingItems, setSortingItems] = useState([
//   {
//    name: "Quantity (MW)",
//    key: role === "CONSUMER" ? "sellEnergy" : "purchaseEnergy",
//    value: "",
//   },
//   {
//    name: "Energy Rate (₹ per Unit)",
//    key: role === "CONSUMER" ? "sellingCost" : "landingCost",
//    value: "",
//   },
//   // {
//   //   name: "Profile matching",
//   //   key: "profileMatching",
//   //   value: ''
//   // },
//  ]);

//  useEffect(() => {
//   if (!isApproveBidsModal) {
//    let elem = document.getElementsByTagName("body");
//    elem.length > 0 && (elem[0].style.overflow = "");
//   }
//  }, [isApproveBidsModal]);

//  const handleEditClick = (item) => {
//   setIsModel(item);
//  };
//  const handleBidsReceived = (item) => {
//   getSelectedCapacityData(item)(dispatch);
//   navigation("/bids_received");
//  };
//  const handleAddNewSlot = (e) => {
//   setIsModel(true);
//  };

//  const getBidsListing = (id) => {
//   biddingGeneratorService
//    .getBidsListByConCapacityId(id)
//    .then((response) => {
//     if (response?.data?.code === 200) {
//      setBidsListing(response?.data?.data);
//     }
//    })
//    .catch((error) => {
//     console.error("Api call error:", error);
//    });
//  };

//  const handleAddBids = (item) => {
//   setIsAddBidsModal(true);
//   setbidItem(item);
//   // getBidsListing(item?.id)
//  };

//  const handlePlaceBidText = (itemIndex) => {
//   const updatedIsBidPlaced = { ...isBidPlaced };
//   updatedIsBidPlaced[itemIndex] = true;
//   setIsBidPlaced(updatedIsBidPlaced);
//  };

//  const closeAddsBidsModal = () => {
//   setIsAddBidsModal(false);
//  };

//  useEffect(() => {
//   let data;
//   async function tokenFunc() {
//    data = await GetTokens(setTokenFound);
//    if (data) {
//     console.log("token is : ", data);
//    }
//    return data;
//   }
//   tokenFunc();
//  }, [setTokenFound]);

//  useEffect(() => {
//   getGeneratorCapacityall()(dispatch);
//   getAllNotifications()(dispatch);
//  }, []);

//  const getMatchingProfiles = (id, data) => {
//   setMatchingProfiles([]);
//   landingCostCalculatorService
//    .getMatchMakingProfilesGenerator(id, data)
//    .then((response) => {
//     if (response?.data?.code === 200) {
//      setMatchingProfiles(response?.data?.data?.page);
//     } else {
//      toast.error(response?.data?.message, toastProperties);
//     }
//    });
//  };

//  const moment = require("moment");

//  const handleResetForm = () => {
//    setFormResetFlag(!formResetFlag);
//  };
//  const handleSelectCard = (data, index) => {
//   handleResetForm()
//   setSelectedCardIndex(index);
//   setSelectedCardData(data);
//   getMatchingProfiles(data.id);
//   setStatusDropDownValue("");
//  };
//  const handleViewProfile = (item) => {
//   localStorage.setItem("companyId", item?.company?.companyId);
//   navigation("/company_profile");
//  };

//  const handleViewConnection = (item) => {
//   let conCapId = item?.id;
//   let genCapId = selectedCardData?.id;
//   biddingGeneratorService
//    .getConnectionDetails(conCapId, genCapId)
//    .then((response) => {
//     if (response?.data?.code === 200) {
//      setIsApproveBidsModal(true);
//      setConnectionData(response?.data?.data);
//     }
//    });
//  };

//  const closeApproveBidsModal = () => {
//   setIsApproveBidsModal(false);
//  };

//  const handleSortClick = (key) => {
//   let sortingItemsCopy = sortingItems.map((item) => {
//    if (item.key === key) {
//     if (item.value === "ASC") {
//      return { ...item, value: "DESC" };
//     } else if (item.value === "DESC") {
//      return { ...item, value: "" };
//     } else {
//      return { ...item, value: "ASC" };
//     }
//    }
//    return item;
//   });
//   setSortingItems(sortingItemsCopy);
//   const sort = sortingItemsCopy.reduce((acc, item) => {
//    if (item.value !== "") {
//     acc[item.key] = item.value;
//    }
//    return acc;
//   }, {});

//   const reqBody = {
//    sort: sort,
//   };

//   getMatchingProfiles(selectedCardData?.id, reqBody);
//  };

//  useEffect(() => {
//   if (allGenCapacity && allGenCapacity.length > 0) {
//    setSelectedCardData(allGenCapacity[0]);
//    getMatchingProfiles(allGenCapacity[0]?.id);
//   } else {
//    setMatchingProfiles(null);
//   }
//  }, [allGenCapacity]);

//  const handleFilterDropdown = (value) => {
//   setStatusDropDownValue(value);
//   const requestBody = {
//    search: [
//     value !== "" && {
//      operation: "LIKE",
//      key:
//       value === "PLACED" || value == ""
//        ? role === "CONSUMER"
//          ? "bids_consumerStatus"
//          : "bids_generatorStatus"
//        : role === "CONSUMER"
//        ? "bids_generatorStatus"
//        : "bids_consumerStatus",
//      value: value,
//      value1: null,
//     },
//     value === "PLACED" && {
//      operation: "NOT",
//      key:
//       value === "PLACED" &&
//       (role === "CONSUMER" ? "bids_generatorStatus" : "bids_consumerStatus"),
//      value: "REJECTED",
//      value1: null,
//     },
//     value === "PLACED" && {
//      operation: "NOT",
//      key:
//       value === "PLACED" &&
//       (role === "CONSUMER" ? "bids_generatorStatus" : "bids_consumerStatus"),
//      value: "ACCEPTED",
//      value1: null,
//     },
//    ].filter(Boolean),
//   };
//   if (allGenCapacity.length > 0) {
//    getMatchingProfiles(selectedCardData?.id, requestBody);
//   }
//  };

//  useEffect(() => {
//   if (!isAddBidsModal) {
//    let elem = document.getElementsByTagName("body");
//    elem.length > 0 && (elem[0].style.overflow = "");
//   }
//  }, [isAddBidsModal]);

//  const ITEM_HEIGHT = 48;

//  const [anchorEl, setAnchorEl] = useState(null);
//  const [acceptedCapData, setAcceptedCapData] = useState(null);
//  const [isOpenChat, setOpenChat] = useState(false);
//  const [UserCapName, setUserCapName] = useState(null);
//  const [fromUserCapName, setFromUserCapName] = useState(null);

//  const open = Boolean(anchorEl);
//  const handleChatClick = (event, item) => {
//   setFromUserCapName(item?.name);
//   setAnchorEl(event.currentTarget);
//   setAcceptedCapData(null);
//   chatService.getAllChatAcceptedCapacities(item?.id, role).then((response) => {
//    if (response?.data?.code === 200) {
//     setAcceptedCapData(response?.data?.data);
//    }
//   });
//  };
//  const handleClose = (e) => {
//   e.stopPropagation();
//   setAnchorEl(null);
//  };
//  const handleCapNameClick = (e, capName) => {
//   e.stopPropagation();
//   setAnchorEl(null);
//   setUserCapName({
//    fromUser: fromUserCapName,
//    toUser: capName,
//   });
//   setOpenChat(true);
//  };
//  useEffect(() => {
//   let bodyElem = document.body;
//   bodyElem.classList.add("custom-body-overflow");
//   return () => {
//    bodyElem.classList.remove("custom-body-overflow");
//   };
//  }, [anchorEl]);

//  return (
//   <>
//   {
//     false ? (
//       
//     ):(
//       <>
//         {isOpenChat && (
//         <Chat
//           isOpen={isOpenChat}
//           closeChatModal={() => {
//           setOpenChat(false);
//           }}
//           UserCapName={UserCapName}
//         />
//         )}
//         {isApproveBidsModal && (
//         <ApproveBidsModal
//           isOpen={isApproveBidsModal}
//           comparedBids={connectionData}
//           closeApproveBidsModal={closeApproveBidsModal}
//           getMatchingProfiles={getMatchingProfiles}
//           selectedCardData={selectedCardData || []}
//         />
//         )}
//         {isModel && <PreviewModel isOpen={isModel} handleSubmit={handleEditClick} />}
//         {isAddBidsModal && (
//         <AddBidsModal
//           isOpen={isAddBidsModal}
//           getMatchingProfiles={getMatchingProfiles}
//           selectedCardData={selectedCardData || []}
//           closeAddsBidsModal={closeAddsBidsModal}
//           bidItem={bidItem}
//           bidsListing={bidsListing}
//           handlePlaceBidText={handlePlaceBidText}
//         />
//         )}
//         <div className="dashboard-container">
//         <div className="container-fluid">
//           <div className="dashboard-title">My Listing</div>
//           <div className="my_capacity_wrap">
//           <div className="capacity-card-scroolbar">
//             <div className="capacity-slots-col">
//             {allGenCapacity.map((item, i) => (
//               <div
//               className={`${
//                 selectedCardIndex === i
//                 ? "capacity-slots-col-card-highlight"
//                 : "capacity-slots-col-card"
//               }`}
//               onClick={() => handleSelectCard(item, i)}
//               key={item.id}
//               >
//               <div className="row ">
//                 <h6 className="col" style={{ width: "190px" }}>
//                 {item.name}
//                 </h6>
//                 {unreadNotificationsObj[item.name] ? (
//                 <OverlayTrigger
//                   placement="right"
//                   overlay={<Tooltip>{unreadNotificationsObj[item.name]}</Tooltip>}
//                 >
//                   <Campaign
//                   className="col"
//                   style={{ marginLeft: "60px", width: "auto" }}
//                   />
//                 </OverlayTrigger>
//                 ) : (
//                 <CampaignOutlined
//                   className="col"
//                   style={{ marginLeft: "60px", width: "auto" }}
//                 />
//                 )}
//               </div>
//               <div style={{ display: "flex" }}>
//                 <div>
//                 <div className="dashboard-slot dashboard-slot-date-time my-2">
//                   <div>
//                   <div>{moment(item.dateStartAt).format("DD-MMM-yyyy")}</div>
//                   <div>{item.slotStartAt}</div>
//                   </div>
//                   <div>-</div>
//                   <div>
//                   <div>{moment(item.dateEndAt).format("DD-MMM-yyyy")}</div>
//                   <div>
//                     {item.slotEndAt &&
//                     (item.slotEndAt === "23:59" ? "24:00" : item.slotEndAt)}
//                   </div>
//                   </div>
//                 </div>
//                 <div className="testfortest">
//                   <div className="energy-cost-unit-box">
//                   <div className="energy-cost-unit-box-content">
//                     Quantity
//                     <p>{item.sellEnergy} MW</p>
//                   </div>
//                   <div className="energy-cost-unit-box-content">
//                     Energy Rate
//                     <p>₹ {item.sellingCost}</p>
//                   </div>
//                   </div>
//                 </div>
//                 <div className="col-md-3">
//                   <div className="d-flex gap-2">
//                   <div onClick={() => handleEditClick(item)}></div>
//                   </div>
//                 </div>
//                 <div className="mt-2" style={{ display: "flex" }}>
//                   <div className="small">
//                   Expires on {moment(item.bidEndAt).format("DD-MMM-yyyy")}{" "}
//                   {moment(item.bidEndAt).format("hh:mm A")}
//                   </div>
//                 </div>
//                 </div>
//                 <div className="c-icons-group">
//                 <div
//                   onClick={(e) => {
//                   e.stopPropagation();
//                   handleEditClick(item);
//                   }}
//                 >
//                   <OverlayTrigger
//                   placement="right"
//                   overlay={<Tooltip>Edit Listing</Tooltip>}
//                   >
//                   <div>
//                     <i className="fa fa-pencil c-icons"></i>
//                   </div>
//                   </OverlayTrigger>
//                 </div>
//                 <div
//                   onClick={(e) => {
//                   e.stopPropagation();
//                   handleBidsReceived(item);
//                   }}
//                 >
//                   <OverlayTrigger
//                   placement="right"
//                   overlay={<Tooltip>View Received {configKey} Requests</Tooltip>}
//                   >
//                   <div>
//                     <i className="fa fa-list c-icons-2"></i>
//                   </div>
//                   </OverlayTrigger>
//                 </div>
//                 <div
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleChatClick(e, item);
//                 }}
//                 >
//                 <OverlayTrigger
//                   placement="right"
//                   overlay={<Tooltip>Chats</Tooltip>}
//                 >
//                   <div className="c-icons-chat">
//                   <ChatIcon />
//                   </div>
//                 </OverlayTrigger>
//                 </div>
//                 <Menu
//                 id="long-menu"
//                 MenuListProps={{
//                   "aria-labelledby": "long-button",
//                 }}
//                 anchorEl={anchorEl}
//                 open={open}
//                 onClose={(e) => handleClose(e)}
//                 PaperProps={{
//                   style: {
//                   maxHeight: ITEM_HEIGHT * 4.5,
//                   width: "30ch",
//                   },
//                 }}
//                 >
//                 {acceptedCapData?.length > 0 ? (
//                   acceptedCapData?.map((capName) => (
//                   <MenuItem
//                     key={capName}
//                     onClick={(e) => {
//                     handleCapNameClick(e, capName);
//                     }}
//                   >
//                     {capName}
//                   </MenuItem>
//                   ))
//                 ) : (
//                   <MenuItem
//                   onClick={(e) => {
//                     handleClose(e);
//                   }}
//                   >
//                   No Chats Initiated With this Listing
//                   </MenuItem>
//                 )}
//                 </Menu>
//                 </div>
//               </div>
//               </div>
//             ))}
//             </div>
//           </div>
//           <div>
//             <button
//             type="button"
//             className="btn btn-new-slot"
//             onClick={handleAddNewSlot}
//             >
//             <i className="fa fa-plus me-1"></i> Add
//             </button>
//           </div>
//           </div>
//         </div>
//         </div>
//         <section className="mt-4">
//         <div className="container-fluid">
//           <div className="row">
//           <div className="col-md-9">
//             {selectedCardIndex != null && (
//             <div>
//               <div className="card_filter_itmes">
//               <div
//                 style={{
//                 color: "#111111",
//                 font: "IBM Plex Serif",
//                 fontWeight: "400",
//                 size: "16px",
//                 }}
//               >
//                 Available Listings: {matchingProfiles?.length || 0}
//               </div>
//               {matchingProfiles?.length > 0 ? (
//                 <div className="dashboard-sorting-card">
//                 {sortingItems?.map((item, i) => (
//                   <div key={i} className="dashboard-sorting-card-body">
//                   <div
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handleSortClick(item.key)}
//                   >
//                     {item.name}
//                     {item.value === "DESC" && <i className="bi bi-arrow-down"></i>}
//                     {item.value === "ASC" && <i className="bi bi-arrow-up"></i>}
//                   </div>
//                   </div>
//                 ))}
//                 </div>
//               ) : (
//                 ""
//               )}
//               <div>
//                 <MdFilterList size={25} color="#5c79e0" />
//                 <select
//                 name="connectionStatus"
//                 value={statusDropDownValue}
//                 onChange={(e) => {
//                   handleFilterDropdown(e.target.value);
//                 }}
//                 className="custom-select-filters"
//                 >
//                 <option value="">All</option>
//                 <option value="PLACED">Placed</option>
//                 <option value="ACCEPTED">Connected</option>
//                 <option value="REJECTED">Declined</option>
//                 </select>
//               </div>
//               </div>
//               {matchingProfiles?.map((item) => {
//               const itemExpiryDate = moment(
//                 `${item?.expiryAt}`,
//                 "DD-MMM-yyyy hh:mm A"
//               );
//               return (
//                 <div key={item?.id} className="dashboard-card">
//                 {/* <div className="dashboard-card-bubble">
//                               {Math.round(item?.matchPercentage)}% Match
//                             </div> */}
//                 <div className="company-profile-with-logo">
//                   <div>
//                   <img src="images/com-profile-img-1.png" alt="company profile" />
//                   </div>
//                   <h4 className="company-profile-with-titile">
//                   {item?.company?.companyName}
//                   </h4>
//                   <h6>-&nbsp;{item?.capacityName}</h6>
//                   {unreadNotificationsObj[item.capacityName] ? (
//                   <OverlayTrigger
//                     placement="left"
//                     overlay={
//                     <Tooltip>{unreadNotificationsObj[item.capacityName]}</Tooltip>
//                     }
//                   >
//                     <Campaign className="annouce-icon" />
//                   </OverlayTrigger>
//                   ) : (
//                   <CampaignOutlined className="annouce-icon" />
//                   )}
//                 </div>
//                 <div className="row table-row">
//                   <div className="col-md-6">
//                   <div className="table-responsive">
//                     <table className=" table">
//                     <tr>
//                       <td>Region</td>
//                       <td>:</td>
//                       <td>{item?.company?.region}</td>
//                     </tr>
//                     <tr>
//                       <td>State</td>
//                       <td>:</td>
//                       <td>{item?.company?.state}</td>
//                     </tr>
//                     <tr>
//                       <td>Credit Rating</td>
//                       <td>:</td>
//                       <td>{item?.company?.creditRating}</td>
//                     </tr>
//                     <tr>
//                       <td>Quantity (MW)</td>
//                       <td>:</td>
//                       <td>{item?.energyInMW}</td>
//                     </tr>
//                     </table>
//                   </div>
//                   </div>
//                   <div className="col-md-6">
//                   <div className="table-responsive">
//                     <table className=" table">
//                     <tr>
//                       <td>Energy Rate (₹ per Unit)</td>
//                       <td>:</td>
//                       <td>{`${item?.consumerLandedCost?.toFixed(2)}`}</td>
//                     </tr>
//                     <tr>
//                       <td>Capacity Start & End Date</td>
//                       <td>:</td>
//                       <td>
//                       {moment(item?.dateStartAt).format("DD-MMM-yyyy")}/
//                       {moment(item?.dateEndAt).format("DD-MMM-yyyy")}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Capacity Start & End Time </td>
//                       <td>:</td>
//                       <td>
//                       {item?.slotStartAt}/
//                       {item?.slotEndAt && item.slotEndAt === "23:59"
//                         ? "24:00"
//                         : item?.slotEndAt}
//                       </td>
//                     </tr>
//                     </table>
//                   </div>
//                   </div>
//                   <div className="col-md-12">
//                   <div className="bid-end-time-col">
//                     Expires on : <CountDownTimer targetDate={itemExpiryDate} />
//                   </div>
//                   </div>
//                 </div>
//                 <div className="dashboard-btn-group">
//                   <Button
//                   variant="text"
//                   color="warning"
//                   size="small"
//                   type="button"
//                   onClick={() => handleViewProfile(item)}
//                   >
//                   <img src="images/mdi_domain.png" /> View Profile
//                   </Button>

//                   {((item?.consumerStatus === "ACCEPTED") ||
//                     (item?.consumerStatus === "REJECTED"))&&<Button
//                   variant="text"
//                   sx={{ color: "black" }}
//                   size="small"
//                   type="button"
//                   onClick={() => handleViewConnection(item)}
//                   >
//                   <MdOutlineElectricBolt size={18} />
//                   View {configKey}
//                   </Button>}
//                   <Button
//                   variant="text"
//                   sx={{ color: "black" }}
//                   color="primary"
//                   size="small"
//                   type="button"
//                   onClick={() => handleAddBids(item)}
//                   >
//                   <i className="fa fa-file-text-o fs-5" aria-hidden="true"></i>
//                   {item?.isEditable
//                     ? `Edit ${configKey} Request `
//                     : `Request to Connect`}
//                   </Button>
//                 </div>
//                 </div>
//               );
//               })}
//             </div>
//             )}
//           </div>
//           <div className="col-md-3">
//             <Filter
//             formResetFlag={formResetFlag}
//             selectedCardData={selectedCardData}
//             getMatchingProfiles={getMatchingProfiles}
//             />
//           </div>
//           </div>
//         </div>
//         </section>
//       </>
//     )
//   }
//   </>
//  );
// };

// export default React.memo(Dashboard);

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainDashboard from "../../components/CommonDashboard/MainDashboard";
import landingCostCalculatorService from "../../components/Services/landingCostCalculator.service";
import { toastProperties } from "../../commons/Toast/Toaster";
import { getGeneratorCapacityall } from "../../store/Capacity/actions";
import { getAllNotifications } from "../../store/Notification/action";
import { GetTokens } from "../../firebase";
import { GET_GEN_CAPACITY_ALL } from "../../store/Capacity/types";

const Dashboard = () => {
  const dispatch = useDispatch();
  const menuData = useSelector(state => state.sessionState?.menuData);
  const isVerified = useSelector((state) => state?.sessionState?.isVerified);
  const acvtiveRoleId = useSelector((state)=> state?.sessionState?.activeRoleId) 
  const allGenCapacity = useSelector(
    (state) => state?.capacityReducer?.allGenCapacity );

  const [isTokenFound, setTokenFound] = useState(false);
  const [matchingProfiles, setMatchingProfiles] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState();
  const [selectedCardData, setSelectedCardData] = useState();
  const [formResetFlag, setFormResetFlag] = useState(false);
  const [filterModal, setFIlterModal] = useState(false);

  const dataFilterString = localStorage.getItem("DATA_FILTER");
  let dataFilter = JSON.parse(dataFilterString);
  
 
  useEffect(() => {
   if (matchingProfiles?.length > 0 && dataFilter?.childId) {
    const matchingProfileRedirect = matchingProfiles.filter(
     (item) => item?.id === dataFilter?.childId
    );
    setMatchingProfiles(matchingProfileRedirect);
    dataFilter = { ...dataFilter, childId: null };
    localStorage.setItem("DATA_FILTER", JSON.stringify(dataFilter));
   }
  }, [matchingProfiles]);
  // useEffect(() => {
  //   let data;
  //   async function tokenFunc() {
  //     data = await GetTokens(setTokenFound);
  //     return data;
  //   }
  //   tokenFunc();
  // }, [setTokenFound]);

  useEffect(() => {
    getGeneratorCapacityall()(dispatch);
    getAllNotifications()(dispatch);
  }, [acvtiveRoleId]);

  useEffect(() => {
    if (allGenCapacity?.length > 0 && dataFilter?.parentId) {
      const selectedOnRedirectIndex = allGenCapacity.findIndex(
       (item) => item?.id === dataFilter?.parentId
      );
      if (selectedOnRedirectIndex !== -1) {
       const selectedOnRedirect = allGenCapacity[selectedOnRedirectIndex];
       setSelectedCardIndex(selectedOnRedirect?.id);
       setSelectedCardData(selectedOnRedirect)
       getMatchingProfiles(selectedOnRedirect?.id);
      }
      dataFilter = { ...dataFilter, parentId: null };
      localStorage.setItem("DATA_FILTER", JSON.stringify(dataFilter));
     }else if (allGenCapacity && allGenCapacity.length > 0) {
      isVerified && getMatchingProfiles(allGenCapacity[0]?.id);
      setSelectedCardData(allGenCapacity[0]);
      setSelectedCardIndex(allGenCapacity[0]?.id);
    } else {
      setMatchingProfiles(null);
    }
  }, [allGenCapacity,acvtiveRoleId]);

  const getMatchingProfiles = (id, data) => {
    setMatchingProfiles([]);
    landingCostCalculatorService
      .getMatchMakingProfilesGenerator(id, data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setMatchingProfiles(response?.data?.data?.page);
          setFIlterModal(false);
        } else {
          toast.error(response?.data?.message, toastProperties);
          setFIlterModal(false);
        }
      });
  };
  return (
    <MainDashboard
      allGenCapacity={allGenCapacity}
      getMatchingProfiles={getMatchingProfiles}
      setMatchingProfiles={setMatchingProfiles}
      selectedCardIndex={selectedCardIndex}
      setSelectedCardIndex={setSelectedCardIndex}
      setSelectedCardData={setSelectedCardData}
      formResetFlag={formResetFlag}
      setFormResetFlag={setFormResetFlag}
      matchingProfiles={matchingProfiles}
      selectedCardData={selectedCardData}
      filterModal={filterModal}
      setFIlterModal={setFIlterModal}
    />
  );
};

export default React.memo(Dashboard);
